import Cookies from 'js-cookie';
import axios from "axios";
import config from "@/config";
import store from "@/stores";
import router from "@/routers";

// ==========================
// ⚙️ Axios Configuration
// ==========================
const axiosInstance=axios.create({
    baseURL: config.apiUrl,
    timeout: 30000,
});

// Request interceptor for auth token
axiosInstance.interceptors.request.use((config) => {
    const token=Cookies.get("token");
    if (token) {
        config.headers.Authorization=`Bearer ${token}`;
    }
    return config;
});

// Response interceptor for handling auth errors
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status===403) {
            router.push({
                path: '/403',
            });
        }
        if (error.response?.status===401) {
            Cookies.remove("token");
            store.state.user={};
            store.state.notifications={};
            store.state.messages={};
            store.state.user={};
            store.state.isLoggedIn=false;
            router.push({
                path: '/401',
            });
        }
        if (error.response?.status===403&&
            error.response?.data?.message?.includes('do not have permission to view this page')) {
            // Cookies.remove("token");
            // store.state.user={};
            // store.state.notifications={};
            // store.state.messages={};
            // store.state.user={};
            // store.state.isLoggedIn=false;
            router.push({
                path: '/403',
                // query: { redirect: router.currentRoute.fullPath }
            });
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;